import { useCallback } from "react";

import type { BasicCustomMailSettingI18nInput } from "@/lib/gql/__generated__/graphql";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import { BasicCustomMailSettingI18nUpdate } from "./mutation";

export const useUpdateCustomMailSettingI18n = () => {
	const { mutationFunc } = useCustomMutation(BasicCustomMailSettingI18nUpdate);

	const updateCustomMailSettingI18n = useCallback(
		async (input: BasicCustomMailSettingI18nInput) => {
			return await mutationFunc({
				variables: {
					input,
				},
			});
		},
		[mutationFunc],
	);

	return { updateCustomMailSettingI18n };
};
